import React, {useState, useRef} from 'react';
import {Button, Col, Container, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowLeftLong,
    faCircle,
    faClock,
    faCopy,
    faFileCircleCheck,
    faMoneyBills,
    faRefresh,
    faTasks
} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import moment from "moment/moment";
import {toast} from "react-toastify";
import ApiService from "../../api/ApiService";
import LocalDataService from "../../api/LocalDataService";
import AgentConsumptionInfoModal from "../../components/AgentConsumptionInfoModal";
import { formatBeijingTime } from "../../api/TimeService";
import {copyToClipboard} from "../../utils/clipboardUtils";

const AgentExecuteRecordList = () => {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const currentPageRef = useRef(1); // 添加ref来同步跟踪当前页码
    const [hasMoreData, setHasMoreData] = React.useState(true); // 新增状态：是否有更多数据
    const [isFetching, setIsFetching] = React.useState(false); // 新增状态：是否正在获取数据


    const [agentConsumptionInfoVisible, setAgentConsumptionInfoVisible] = React.useState(false); // 新增状态：是否正在获取数据
    const [curAgentConsumptionInfo, setCurAgentConsumptionInfo] = React.useState([]); // 新增状态：是否正在获取数据
    const api = new ApiService();
    // 模拟数据请求函数
    const fetchMoreData = async () => {
        if (!hasMoreData || isFetching) return; // 如果没有更多数据或正在获取数据，直接返回

        setIsFetching(true); // 设置为正在获取数据

        const result = await api.executeAgentResultList(10, currentPageRef.current);
        const newData = result.data

        // // 假设每次加载10条新数据
        // const newData = Array.from({length: 10}, (_, index) => ({
        //     id: 2102,
        //     user_id: 315608,
        //     token: "",
        //     workflow_id: "7490463549186539531",
        //     bot_id: null,
        //     parameters: "{\"bgm\":\"治愈\",\"sound\":\"雷电\"}",
        //     app_id: null,
        //     outputs: "{\"node_status\": \"{}\", \"Output\": \"{\\\"output\\\":\\\"\\u6cbb\\u6108\\\"}\"}",
        //     debug_url: "https://www.coze.cn/work_flow?execute_id=7522751718430392346&space_id=7395390088370880563&workflow_id=7490463549186539531&execute_mode=2",
        //     execute_id: "7522751718430392346",
        //     status: 2,
        //     money: 10,
        //     time: "2025-07-03T15:18:46",
        //     update_time: "2025-07-03T15:18:46"
        // }));
        setData(prevData => [...prevData, ...newData]);
        currentPageRef.current = currentPageRef.current + 1; // 同步更新ref
        setIsFetching(false); // 重置为未获取数据状态
        if (newData.length < 10) {
            setHasMoreData(false);
        }

    };

    // 使用 Intersection Observer 监听元素是否进入视口
    const observer = React.useRef();
    const lastElementRef = React.useCallback(node => {
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMoreData && !isFetching) { // 只有在还有更多数据且未获取数据时才触发加载
                fetchMoreData();
            }
        });
        if (node) observer.current.observe(node);
    }, [hasMoreData, isFetching]);

    const refreshList = () => {
        setData([]);
        currentPageRef.current = 1; // 重置ref
        setHasMoreData(true);
        fetchMoreData();
    }

    const [user, setUser] = useState(null);
    const [isMobile, setIsMobile] = React.useState(false);
    React.useEffect(() => {
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };

        handleResize(); // 初始化时调用

        const userData = LocalDataService.load_user_data();
        setUser(userData);

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const openCozeAgent = async (info) => {
        const res = await api.getAgentInfo(info?.id);
        var toekn = null;
        if (res.code === 200) {
            toekn = res.data.token;
        } else if (res.code === -4001) {
            toast.error('请先登录');
            navigate('/home');
            return
        } else {
            toast.error(res.msg);
            return
        }
        if (!toekn) {
            toast.error("智能体授权获取失败");
            return
        }
        // eslint-disable-next-line no-undef
        const cozeWebSDK = new CozeWebSDK.WebChatClient({
            config: {
                botId: info?.cozeAgentId,
                isIframe: false,
                botInfo: {
                    // parameters: {
                    //     user_token: LocalDataService.loadApiToken(),
                    //     agent_id:agentInfo?.id,
                    // }
                }
            },
            auth: {
                type: 'token',
                token: toekn,
                onRefreshToken: async () => toekn,
            },
            userInfo: {
                id: user?.user?.id + '',
                url: 'https://lf-coze-web-cdn.coze.cn/obj/coze-web-cn/obric/coze/favicon.1970.png',
                nickname: user?.user?.bindingMobile ? user.user.bindingMobile : '微信用户',
            },
            ui: {
                base: {
                    icon: 'https://lf-coze-web-cdn.coze.cn/obj/coze-web-cn/obric/coze/favicon.1970.png',
                    layout: isMobile ? 'mobile' : 'pc',
                    zIndex: 10000,
                    lang: 'zh-CN',
                },
                asstBtn: {
                    isNeed: false,
                },
                footer: {
                    isShow: true,
                    expressionText: '您的智能体id为{{id}} 沸推api_token为{{token}}',
                    linkvars: {
                        id: {
                            text: info?.id,
                            link: info?.id,
                        },
                        token: {
                            text: LocalDataService.loadApiToken(),
                            link: LocalDataService.loadApiToken()
                        },
                    }
                },
                chatBot: {
                    title: "",
                    uploadable: false,
                    isNeedAudio: false,
                    isNeedFunctionCallMessage: false,
                },
            },

        });
        cozeWebSDK.showChatBot();
    }

    return (
        <Container>
            <div className={'pb-3'}>
                <div style={{alignItems: 'start', display: 'flex',}}>
                    <button style={{
                        color: '#101217',
                        border: 'none',
                        background: '#02C8E3',
                        borderRadius: '12px',
                        padding: '6px 22px',
                    }} onClick={() => {
                        navigate(-1)
                    }}>
                        <span style={{marginRight: '10px'}}>
                        <FontAwesomeIcon icon={faArrowLeftLong} color={'#101217'} size={'1x'}/>
                      </span>
                        返回
                    </button>
                </div>
                <div style={{background: '#15191E', padding: '24px', borderRadius: '20px',}}>
                    <div className={'mb-3 d-flex justify-content-between'}
                         style={{background: '#2C2F37', padding: '20px',}}>
                        <div style={{color: '#02C8E3', textAlign: 'start', fontSize: '22px',}}>
                            智能体执行记录
                        </div>

                        <Button
                            onClick={() => {
                                refreshList()
                            }}
                            style={{
                                background: 'transparent',
                                color: '#02C8E3',
                                marginRight: '10px',
                                borderColor: '#02C8E3',
                                borderRadius: '8px',
                            }} size={'sm'}>
                            <FontAwesomeIcon icon={faRefresh} color={'#02C8E3'} size={'1x'}
                                             style={{marginRight: '4px'}}/>
                            刷新
                        </Button>
                    </div>

                    {data?.map((item, index) => (
                        <div key={index} style={{
                            position: 'relative',
                            marginBottom: '20px',
                            padding: '16px',
                            borderRadius: '8px',
                            overflowWrap: 'anywhere'
                        }}>
                            {/*1成功 -1失败 2执行中 0等待执行 */}
                            <span className={'badge rounded-pill'} style={{
                                background: '#242836',
                                position: 'absolute',
                                fontSize: '14px',
                                right: '16px',
                                top: '26px',
                                color: item.status === 1 ? '#04D7F3' : (item.status === -1 ? '#DE4444' : '#f4f238'),
                            }}><FontAwesomeIcon icon={faCircle}
                                                width={'6px'}/> {item.status === 1 ? '执行成功' : (item.status === -1 ? '执行失败' : '执行中')}</span>
                            <div className={'mb-3'} style={{
                                color: '#B4BFC5',
                                fontSize: '16px',
                                textAlign: 'start',
                                padding: '10px',
                                fontWeight: 'bold',
                                background: 'rgba(255,255,255,0.1)',
                            }}>{item.title}</div>
                            <Row style={{textAlign: 'start'}}>

                                <Col md={6}>
                                    <div className={'mb-3'} style={{
                                        color: '#B4BFC5',
                                        fontSize: '14px',
                                        paddingLeft: '5px',
                                        paddingRight: '5px',
                                        textAlign: 'start',
                                    }}><FontAwesomeIcon icon={faTasks} color={'#02C8E3'} style={{width: '20px', marginRight: '4px'}}/>任务ID:{item.taskId}
                                        <FontAwesomeIcon icon={faCopy} color={'#02C8E3'} style={{width: '20px', marginLeft: '4px'}} onClick={() => {
                                            copyToClipboard(item.taskId)
                                        }}/>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className={'mb-3'} style={{
                                        color: '#B4BFC5',
                                        fontSize: '14px',
                                        paddingLeft: '5px',
                                        paddingRight: '5px',
                                        textAlign: 'start',
                                    }}><FontAwesomeIcon icon={faClock}
                                                        color={'#02C8E3'} style={{ width: '20px',marginRight: '4px'}}/>执行时间:{formatBeijingTime(item.created)}
                                    </div>
                                </Col>
                            </Row>
                            <Row style={{textAlign: 'start'}}>
                                <Col md={6}>
                                    <div className={'mb-3'} style={{
                                        color: '#B4BFC5',
                                        fontSize: '14px',
                                        paddingLeft: '5px',
                                        paddingRight: '5px',
                                        display: 'flex',
                                        justifyContent: 'start',
                                    }}><span style={{
                                        textAlign: 'start',
                                        lineHeight: '2',
                                        display: '-webkit-box',
                                        WebkitBoxOrient: 'vertical',
                                        WebkitLineClamp: 1, overflow: 'hidden',
                                        overflowWrap: 'anywhere'
                                    }}>
                                <FontAwesomeIcon icon={faMoneyBills}
                                                 color={'#02C8E3'} style={{width: '20px',marginRight: '4px'}}/>消耗金额: ￥{(item.total / 100).toFixed(2)}</span>
                                        <Button size={'sm'} style={{
                                            color: '#02C8E3',
                                            border: '1px solid #02C8E3',
                                            background: 'none',
                                            flexShrink: 0,
                                            borderRadius: '4px',
                                            padding: '2px 11px',
                                            marginLeft: '10px',
                                        }} onClick={() => {
                                            setCurAgentConsumptionInfo(item.points)
                                            setAgentConsumptionInfoVisible(true)
                                        }}>查看明细
                                        </Button>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className={'mb-3'} style={{
                                        color: '#B4BFC5',
                                        fontSize: '14px',
                                        paddingLeft: '5px',
                                        paddingRight: '5px',
                                        display: 'flex',
                                        justifyContent: 'start',
                                    }}><span style={{
                                        textAlign: 'start',
                                        lineHeight: '2',
                                        display: '-webkit-box',
                                        WebkitBoxOrient: 'vertical',
                                        WebkitLineClamp: 1, overflow: 'hidden',
                                        overflowWrap: 'anywhere'
                                    }}>
                                <FontAwesomeIcon icon={faFileCircleCheck}
                                                 color={'#02C8E3'} style={{width: '20px',marginRight: '4px'}}/>执行结果:</span>
                                        <Button size={'sm'} style={{
                                            color: '#02C8E3',
                                            border: '1px solid #02C8E3',
                                            background: 'none',
                                            flexShrink: 0,
                                            borderRadius: '4px',
                                            padding: '2px 11px',
                                            marginLeft: '10px',
                                        }} onClick={() => {
                                            openCozeAgent(item)
                                        }}>去查看
                                        </Button>
                                    </div>
                                </Col>
                            </Row>


                        </div>
                    ))}
                    {/* 观察目标元素 */}
                    {hasMoreData ? (
                        <div ref={lastElementRef}
                             style={{textAlign: 'center', marginTop: '20px', color: 'white'}}>加载更多...</div>
                    ) : (
                        <div style={{textAlign: 'center', marginTop: '20px', color: 'white'}}>没有更多数据了</div>
                    )}
                </div>
            </div>
            <AgentConsumptionInfoModal visible={agentConsumptionInfoVisible} agentConsumptionInfo={curAgentConsumptionInfo}  onClose={() => setAgentConsumptionInfoVisible(false)}/>

        </Container>

    );
};

export default AgentExecuteRecordList;